import { useRef, useCallback } from 'react';
import ChatEditPage from '.';
import StateView from '../../atoms/State';
import useLoader from '../../hooks/useLoader';
import { ChatId } from '../../types/Types';
import { Button, Checkbox, Grid, Skeleton } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export interface ChatEditModalData {
    id: ChatId;
}

export function ChatEditDialogLoader() {
    const { t } = useTranslation();
    return (
        <Grid columns={2}>
            {new Array(4).fill('').map((_, i) => (
                <Grid.Col key={i} span={2}>
                    <Skeleton height={21} width={50} mb={4} opacity={0.5}></Skeleton>
                    <Skeleton height={36} width="100%" opacity={0.4}></Skeleton>
                </Grid.Col>
            ))}
            <Grid.Col span={2}>
                <Skeleton opacity={0.4}>
                    <Checkbox label={t('addedUsersCanSeeOldStuff')} />
                </Skeleton>
            </Grid.Col>
            <Grid.Col span={2}>
                <Skeleton opacity={0.4}>
                    <Button>{t('action.submit')}</Button>
                </Skeleton>
            </Grid.Col>
        </Grid>
    );
}

export default function ChatEditDialog(props: { id: ChatId; onClose: () => void }) {
    const ref = useRef();
    const { state, revalidate } = useLoader(
        useCallback((x) => x.loadChatForEditing(props.id), [props.id])
    );
    return (
        <StateView state={state} retry={revalidate} loading={ChatEditDialogLoader}>
            {(data) => <ChatEditPage ref={ref} chatEdit={data} handleClose={props.onClose} />}
        </StateView>
    );
}
